//402px 未満は JS で viewport を固定する
(function () {
  const viewport = document.querySelector('meta[name="viewport"]');

  function switchViewport() {
    const value =
      window.outerWidth > 401 ?
      'width=device-width,initial-scale=1' :
      'width=402';
    if (viewport.getAttribute('content') !== value) {
      viewport.setAttribute('content', value);
    }
  }
  addEventListener('resize', switchViewport, false);
  switchViewport();
})();

// アナウンスメントバーの高さに応じてオーバーレイの高さを調整
document.addEventListener('DOMContentLoaded', function() {
  const closeBtn = document.querySelector('.js-announcement-close');
  const announcement = document.querySelector('.js-announcement-bar');
  const overlay = document.querySelector('.c-header__overlay');
  const overlayDrawer = document.querySelector('.c-header__overlay__drawer');

  // ページ読み込み時にアナウンスメントバーの高さを取得してオーバーレイにセット
  let announcementHeight = 0;
  
  if (announcement && window.getComputedStyle(announcement).display !== 'none') {
    announcementHeight = announcement.offsetHeight;
  }
  
  const heightValue = `calc(100vh - 100% - ${announcementHeight}px)`;

  if (overlay) {
    overlay.style.height = heightValue;
  }

  if (overlayDrawer) {
    overlayDrawer.style.height = heightValue;
  }

  // アナウンスメントバーを閉じた時の処理
  if (closeBtn && announcement) {
    closeBtn.addEventListener('click', function() {
      announcement.classList.add('is-hidden');

      // 両方のオーバーレイの高さを更新(アナウンスメントバー分を引かない)
      const newHeightValue = 'calc(100vh - 100%)';

      if (overlay) {
        overlay.style.height = newHeightValue;
      }

      if (overlayDrawer) {
        overlayDrawer.style.height = newHeightValue;
      }
    });
  }
});

// 価格表示のフォーマット
(function() {
  const taxrate = parseFloat(document.body.dataset.taxrate) || 0;

  function formatPrices() {
    const priceElements = document.querySelectorAll('[data-price]');

    priceElements.forEach(function(priceElement) {
      const price = priceElement.getAttribute('data-price');
      const priceValue = priceElement.querySelector('.js-price-value');
      const isProductPrice = priceElement.hasAttribute('data-product-price');

      if (price && priceValue) {
        let priceInYen;

        if (isProductPrice) {
          priceInYen = (Number(price) / 100) * (1 + taxrate / 100);
        } else {
          priceInYen = Number(price);
        }

        const formatted = Math.floor(priceInYen).toLocaleString('ja-JP');
        priceValue.textContent = formatted;
      }
    });

    const comparePriceElements = document.querySelectorAll('[data-product-compare-price]');

    comparePriceElements.forEach(function(priceElement) {
      const price = priceElement.getAttribute('data-compare-price');
      const priceValue = priceElement.querySelector('.js-compare-price-value');

      if (price && priceValue) {
        const priceInYen = (Number(price) / 100) * (1 + taxrate / 100);
        const formatted = Math.floor(priceInYen).toLocaleString('ja-JP');
        priceValue.textContent = formatted;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', formatPrices);
  } else {
    formatPrices();
  }

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', formatPrices);
  }
})();

// アコーディオン
const acBtn = document.querySelectorAll(".js-accordion__toggle");

function acToggle() {
  const content = this.nextElementSibling;

  if (content.classList.contains("is-open")) {
    // 閉じる処理（即座に閉じる）
    content.style.height = "0";
    content.classList.remove("is-open");
  } else {
    // 開く処理（即座に開く）
    content.style.height = "auto";
    content.classList.add("is-open");
  }

  this.classList.toggle('is-open');
}

for (let i = 0; i < acBtn.length; i++) {
  acBtn[i].addEventListener("click", acToggle);
}

// 目次の「もっと見る」ボタン
document.querySelectorAll('.js-readmore__toggle').forEach(toggle => {
  toggle.addEventListener('click', function(e) {
    e.preventDefault();

    let content = this.previousElementSibling;
    while (content && !content.classList.contains('js-readmore__content')) {
      content = content.previousElementSibling;
    }

    if (content) {
      content.classList.add('is-shown');
    }

    this.classList.add('is-hidden');
  });
});